module.exports = __webpack_public_path__ + "img/bg-top-m.2abdd1d7.jpg";